export default class ActivityForm {
  constructor(element) {
    this.form = element

    this.dateSelect = element.querySelector('select.js-activitydatefield')
    this.amountelements = element.querySelectorAll('select.js-maxamountsync')

    if (!this.dateSelect || !this.amountelements.length) {
      return
    }

    this.maxAmountOptions = this.amountelements[0]?.getAttribute('max')
      ? parseInt(this.amountelements[0].getAttribute('max'), 10)
      : 100 // 100 is fallback

    this.init()
  }

  init() {
    if (this.amountelements) {
      this.updateSelectElements()

      for (const amountelement of this.amountelements) {
        amountelement.addEventListener('change', () => this.checkMaxValues())
      }
    }

    if (this.dateSelect) {
      this.dateSelect.addEventListener('change', () => this.updateSelectElements())
    }
  }

  updateSelectElements() {
    for (const amountelement of this.amountelements) {
      amountelement.value = ''
      amountelement.querySelector('option').innerHTML = 'Kies aantal'
      amountelement.querySelector('option').disabled

      this.setOptionValues(amountelement, this.maxAmountOptions)
    }
  }

  getAvailable() {
    if (this.dateSelect) {
      const selectedIndex = this.dateSelect.selectedIndex
      const selectedOption = this.dateSelect.getElementsByTagName('option')[selectedIndex]
      return parseInt(selectedOption.dataset.available, 10)
    } else {
      return parseInt(this.maxAmountOptions, 10)
    }
  }

  setOptionValues(selectElement, available) {
    if (!available) return

    selectElement.disabled = true

    const options = selectElement.querySelectorAll('option[value]:not([value=""])')

    if (options.length > this.maxAmountOptions) {
      options.forEach((element) => {
        if (parseInt(element.value, 10) > this.maxAmountOptions) {
          element.remove()
        }
      })
    }

    if (available < options.length) {
      options.forEach((element) => {
        if (parseInt(element.value, 10) > available) {
          element.remove()
        }
      })
    } else if (available > options.length) {
      const max = available < this.maxAmountOptions ? available : this.maxAmountOptions

      let i = options.length + 1
      while (i < max + 1) {
        const newOption = document.createElement('option')
        newOption.value = i
        newOption.innerHTML = i

        selectElement.append(newOption)
        i++
      }
    }

    selectElement.disabled = false
  }

  checkMaxValues() {
    let totalSelected = 0

    for (const amountelement of this.amountelements) {
      if (amountelement.value) {
        totalSelected = totalSelected + parseInt(amountelement.value)
      }
    }

    if (totalSelected > this.maxAmountOptions) {
      for (const amountelement of this.amountelements) {
        amountelement.value = ''
        amountelement.querySelector('option').innerHTML =
          'Kies maximaal ' + this.maxAmountOptions + ' personen in totaal.'
      }
    }
  }
}
